import isEqual from 'lodash/isEqual';
import pick from 'lodash/pick';

export default function areRectsEqual(rectA: DOMRect, rectB: DOMRect): boolean {
  const propertyNames = ['bottom', 'height', 'left', 'right', 'top', 'width', 'x', 'y'];
  return isEqual(pick(rectA, propertyNames), pick(rectB, propertyNames));
}
